import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { baseUrl, baseAPI, loginFile, IMG_ROOT } from './endpoint';
import { GlobalEventsManager } from './global-events-manager';

interface Check5thLogin {
  loginCount: Number;
  feedbackCount: Number;
  hasAtLeast5Logins: Boolean;
}

@Injectable({
  providedIn: 'root'
})

export class LoginService {

  private url = baseUrl + loginFile;
  private check5thLoginAPI = `${baseAPI}/reporting/check5thLogin`;

  shouldShowFeedbackModal: Boolean = false;

  constructor(
    private http: HttpClient,
    private globalEventsManager: GlobalEventsManager
  ) { }

  doLogin(user: any, pass: any): any {
    const url = `${this.url}`;
    return this.http.post<any>(url, { function: 'doLogin', item1: user, item2: pass })
    .pipe(
      catchError(this.handleError('doLogin', []))
    );
  }

  check5thLogin(token: String): Observable<any> {
    const body = {
      token,
      internalOrExternal: 'internal'
    };
    return this.http.post<Check5thLogin>(this.check5thLoginAPI, body)
    .pipe(
      catchError(error => {
        console.error(error);

        if (!error.status) {
          return throwError('Connection Error');
        }

        if (error.error && error.error.text === 'expire') {
          this.globalEventsManager.logout(true);
          return throwError(error.error.text);
        }

        return throwError(error.error);
      })
    );
  }

  getBackground(): Promise<string> {
    const splittedURL = window.location.href.split('/');
    const projectName = splittedURL[splittedURL.indexOf('#') - 1];
    // const smallLoginImage = `${IMG_ROOT}/login/${projectName}_login_sm.jpg`;

    return new Promise(resolve => {
      // const image = new Image();
      // image.onload = () => {
      //   resolve(`${IMG_ROOT}/login/${projectName}_login.jpg`);
      // };
      // image.onerror = () => {
      //   resolve(`${IMG_ROOT}/login/_login.jpg`);
      // };
      // image.src = smallLoginImage;

      resolve(`${IMG_ROOT}/login/_login.jpg`);
    });
  }

  private handleError<T> (operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
      if (error.error.text === 'expire') {
        this.globalEventsManager.logout(true);
      } else {
        if (error.error.text !== 'Could not Authenticate User') {
          console.error(error);
        }
      }
      return of(result as T);
    };
  }
}
